import React from 'react';
import {
    required,
    SimpleForm,
    DisabledInput,
    SelectInput,
    choices,
    CardActions,
    ListButton, 
    Toolbar, 
    SimpleShowLayout,
    TextField,
    DateField,
    showNotification,
    Show,
    ImageField,
    EditButton,
    ImageInput,
} from 'react-admin';
import ErrorBoundary from '../ErrorBoundary';

export const styles = {

     inlineBlock: {
         display: 'inline-flex', 
         marginRight: '1rem' 
     },
     inlineBlockLeft: {
         display: 'inline-flex',
         float:    'left', 
         marginRight: '1rem' 
     },
     hidden : {
         display: 'none'
     },
     visible : {
         display: 'visible'
     }
 };
 
const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const UserEditActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <EditButton basePath={basePath} record={data} />
        <ListButton basePath={basePath} />
    </CardActions>
);

const UserTable = ({ record }) => {
   
    console.log(record)
    return (
        <div style={{width: '100%'}}>
            <table style={{width: '100%', textAlign: 'left',fontFamily: 'arial', size: '10', color:"gray" }} cellSpacing="3" cellPadding="3">
            <tbody >
            <tr>
                <th >User Name:</th><td colSpan="3">{record.user_name} </td>
            </tr>
            <tr>
                <th>First Name:</th><td>{record.first_name}</td>
                <th>Last Name:</th><td>{record.last_name}</td>
            </tr>
            <tr>
                <th>Title:</th><td>{record.title}</td>
                <th>Site Name:</th><td>{record.name}</td>
            </tr>
            <tr>
                <th>Is IP Address restriction applied?</th><td>{(record.is_ip)? 'Yes': 'No'}</td>
                <th>IP Address:</th><td>{record.ipaddress}</td>
            </tr>
            <tr>
                <th>Is Active?</th><td>{(record.is_active)? 'Yes': 'No'}</td>
                <th>Is time restriction applied?</th><td>{(record.time_restricted)? 'Yes': 'No'}</td>
            </tr>
            <tr><td colSpan="2">&nbsp;</td></tr>
            </tbody>
        </table>
        
        {(record.time_restricted === 1) && 
       
        <table style={{width: '100%',fontFamily: 'arial',fontFamily: 'arial', size: '10', color:"gray"  }} cellSpacing="3" cellPadding="3">
            
            <thead style={{background: "silver"}}>
                <tr>
                    <th>Days</th>
                    <th align="center">Permitted Hours</th> 
                </tr>
            </thead>
            <tbody style={{size: 'small', textAlign: 'left'}} >
                <tr>
                    <th>Moday</th><td>{(record.mon_start_hr)? record.mon_start_hr: '00'}:{(record.mon_start_min)? record.mon_start_min: '00'} to {(record.mon_end_hr)?record.mon_end_hr: '00'}:{(record.mon_end_min)? record.mon_end_min: '00'}</td>
                </tr>
                <tr>
                    <th>Tuesday</th><td>{(record.tue_start_hr)? record.tue_start_hr: '00'}:{(record.tue_start_min)? record.tue_start_min: '00'} to {(record.tue_end_hr)?record.tue_end_hr: '00'}:{(record.tue_end_min)? record.tue_end_min: '00'}</td>
                </tr>
                <tr>
                    <th>Wednesday</th><td>{(record.wed_start_hr)? record.wed_start_hr: '00'}:{(record.wed_start_min)? record.wed_start_min: '00'} to {(record.wed_end_hr)?record.wed_end_hr: '00'}:{(record.wed_end_min)? record.wed_end_min: '00'}</td>
                </tr>
                <tr>
                    <th>Thursday</th><td>{(record.thu_start_hr)? record.thu_start_hr: '00'}:{(record.thu_start_min)? record.thu_start_min: '00'} to {(record.thu_end_hr)?record.thu_end_hr: '00'}:{(record.thu_end_min)? record.thu_end_min: '00'}</td>
                </tr>
                <tr>
                    <th>Friday</th><td>{(record.fri_start_hr)? record.fri_start_hr: '00'}:{(record.fri_start_min)? record.fri_start_min: '00'} to {(record.fri_end_hr)?record.fri_end_hr: '00'}:{(record.fri_end_min)? record.fri_end_min: '00'}</td>
                </tr>
                <tr>
                    <th>Saturday</th><td>{(record.sat_start_hr)? record.sat_start_hr: '00'}:{(record.sat_start_min)? record.sat_start_min: '00'} to {(record.sat_end_hr)?record.sat_end_hr: '00'}:{(record.sat_end_min)? record.sat_end_min: '00'}</td>
                </tr>
                <tr>
                    <th>Sunday</th><td>{(record.sun_start_hr)? record.sun_start_hr: '00'}:{(record.sun_start_min)? record.sun_start_min: '00'} to {(record.sun_end_hr)?record.sun_end_hr: '00'}:{(record.sun_end_min)? record.sun_end_min: '00'}</td>
                </tr>
            </tbody>
        </table>
       
        }
        </div>

    )
}



const UserShow = ({ classes, ...props }) => (
<ErrorBoundary>  
    <Show actions={<UserEditActions />}   {...props}  title="Edit user">
       <SimpleShowLayout>
            <UserTable />
            
        </SimpleShowLayout>
        
    </Show>
    </ErrorBoundary>  
);

export default UserShow;
